import React from "react";

import isEmpty from "lodash.isempty";
import Link from "next/link";
import styled from "styled-components";

import { useStores } from "../../../contexts/StoreContext";
import useDevice from "../../../shared/customHooks/useDevice";

const StyledContact = styled.div`
  color: black;
  text-align: ${({ isMobile }) => (isMobile ? "start" : "end")}; ;
`;

function MultiColumnContactInfo() {
  const { configStore } = useStores();
  const { contact } = configStore.config;
  const { isMobile } = useDevice();

  if (isEmpty(contact)) {
    return null;
  }

  return (
    <StyledContact className="contactInfo" isMobile={isMobile}>
      {contact.phoneNumber && (
        <p className="mb-3">
          <span className="fw-">TELEPHONE</span>
          <br />
          <a href={`tel:${contact.phoneNumber}`}>{contact.phoneNumber}</a>
        </p>
      )}
      {contact.email && (
        <p className="mb-3">
          EMAIL
          <br />
          <a href={`mailto:${contact.email}`}>{contact.email}</a>
        </p>
      )}
      {!isMobile && (
        <p>
          <span className="me-5">
            Site by <a href="https://talent-funnel.com">Talent Funnel</a>
          </span>
          <Link href="/sitemap">Sitemap</Link>
        </p>
      )}
    </StyledContact>
  );
}

export default MultiColumnContactInfo;
